// extracted by mini-css-extract-plugin
export default {"darkModeContainer":"darkMode_darkModeContainer__DvD76","titleWrapper":"darkMode_titleWrapper__+emOx","title":"darkMode_title__5f9iF"};